import { Component, forwardRef, Input } from '@angular/core'

import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { TagEditorComponent } from '../../../event/components/tag-editor/tag-editor.component'
import { TranslocoPipe } from '@jsverse/transloco'

export interface JournalEntryAssistantRef {
  assistantId: number
  fullname: string
}

export type JournalEntryValue = { assistantId: number; content: string }[]

@Component({
  selector: 'app-assistance-editor-journal-entries',
  templateUrl: './assistance-editor-journal-entries.component.html',
  styleUrls: ['./assistance-editor-journal-entries.component.scss'],
  standalone: true,
  imports: [FormsModule, IonicModule, TagEditorComponent, TranslocoPipe],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssistanceEditorJournalEntriesComponent),
      multi: true,
    },
  ],
})
export class AssistanceEditorJournalEntriesComponent implements ControlValueAccessor {
  @Input() mappedAssignments: ReadonlyArray<JournalEntryAssistantRef> = []
  @Input() currentClientId: number | null

  private _value: JournalEntryValue = []
  private _onChange: (value: JournalEntryValue) => void = () => {}
  private _onTouched: () => void = () => {}
  private _disabled = false

  getContent(assistantId: number): string {
    const entry = this._value.find((e) => e.assistantId === assistantId)
    return entry?.content ?? ''
  }

  onContentChange(assistantId: number, content: string): void {
    const next = [...this._value]
    const idx = next.findIndex((e) => e.assistantId === assistantId)
    if (idx >= 0) next[idx] = { assistantId, content }
    else next.push({ assistantId, content })
    this._value = next
    this._onChange(next)
    this._onTouched()
  }

  writeValue(value: JournalEntryValue | null): void {
    this._value = Array.isArray(value) ? [...value] : []
  }

  registerOnChange(fn: (value: JournalEntryValue) => void): void {
    this._onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled
  }
}
